<template lang="pug">
  .folder-card-container
    .folder-card-info.relative.row.space-between(:style='setFolderColor(index)')
      .novelty-badge.absolute
        img(:src='require(`@/assets/${locale}_noveltyBadge.svg`)' width='165px' height='165px' v-if='kimpleFolder.novelty')
      .folder-img.absolute.width-100(:style='setFolderImage')
      router-link.column(:to='`/kimple-folders/${kimpleFolder.id}`')
        .folder-text-container.column
          span.folder-card-title.title-medium.white {{ kimpleFolder.title }}
          span.folder-hashtags-text.white.m-top-08 {{ $t('kimpleFolderCard.hashtag', { text: kimpleFolder.hashtag }) }}
        .row.ages.m-top-auto
          span.folder-age-desc.white(v-for='ageRange in sortedAges')
            | {{ $t('kimpleFolderCard.agesTag', { min: ageRange.minAge, max: ageRange.maxAge }) }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import copyToMyFoldersIcon from '@/assets/file_copy.svg'
import defaultImage from '@/assets/empty_profile.svg'
import { kimpleFolderColor } from '../constants/kimpleFolders'

export default {
  props: {
    kimpleFolder: { type: Object, required: true },
    index: { type: Number, required: true }
  },
  data() {
    return {
      copyToMyFoldersIcon,
      defaultImage
    }
  },
  computed: {
    ...mapState({
      showDoneModal: state => state.behavior.doneModal.show,
      locale: state => state.behavior.locale
    }),
    sortedAges() {
      return this.kimpleFolder.ageRanges
        .map(age => age)
        .sort((a, b) => a.minAge - b.minAge)
    },
    setFolderImage() {
      const image = this.kimpleFolder.feedThumbnail
      return {
        '--folder-image': `url("${/[\s()]+/.test(image) ? encodeURI(image) : image}")`
      }
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'copyKimpleFolder'
    ]),
    setFolderColor(position) {
      return {
        '--folder-color': kimpleFolderColor[position % 3].color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';
@import 'src/scss/common/texts';

.VueCarousel-inner {
  .VueCarousel-slide {
    .folder-card-container {
      margin-left: 10px;
      --max-width: 430px;
      margin-right: 10px;
    }
  }
}

.folder-card-container {
  height: 150px;
}

.folder-card-info {
  padding: 10px;
  padding-top: 15px;
  height: 100%;
  background-color: var(--folder-color);
  border-radius: 10px;
  min-width: 310px;
  overflow: hidden;
  z-index: 1;
}

.ages {
  display: inline-flex;
  &.background {
    background: rgba(0,0,0,0.5);
    border-radius: 5px;
    padding: 2px 5px;
  }
}

.folder-card-title {
  line-height: 27px;
}

.folder-hashtags-text {
  @extend .text-normal;
}

.folder-text-container {
  max-width: 280px;
}

.folder-age-desc:not(.noage) {
  padding-left: 16px;
  position: relative;

  &:not(:last-child) {
    margin-right: 16px;
  }

  &::before {
    background-color: $white;
    border-radius: 100%;
    content: '';
    height: 8px;
    left: 0;
    position: absolute;
    top: 2.5px;
    width: 8px;
  }
}

.folder-img {
  background-image: var(--folder-image), linear-gradient(180deg, $black 0%, $dark-gray-translusent 100%);;
  background-size: cover;
  transform: rotate(-45deg);
  border-radius: 15px;
  right: 10px;
  bottom: -22px;
  height: 110px;
  width: 80px;
  z-index: -1;
}

.copy-folder-icon {
  width: 20px;
  bottom: 10px;
  right: 10px;
  z-index: 1;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  &:disabled{
    opacity: 0.5;
    cursor: wait;
  }
}

.novelty-badge{
  position: absolute;
  right: -38px;
  top: -38px;
  transform: scale(80%);
  z-index: 1;
}

@media screen and (max-width: $mobile-break) {
  .folder-card-info {
    padding: 10px 5px;
    align-items: center;
  }
}
</style>
